import React from 'react';
import Icon from '@atlaskit/icon';
import ExportIcon from '@atlaskit/icon/glyph/export';
import FileIcon from '@atlaskit/icon/glyph/file';
import InviteTeamIcon from '@atlaskit/icon/glyph/invite-team';
import UnlockFilledIcon from '@atlaskit/icon/glyph/unlock-filled';
import { AutomationGlyph } from '@atlassian/jira-automation-menu/src/common/assets/automation';
import type { Benefit } from './benefits-list';
import messages from './messages';

const AutomationIcon = ({ label }: { label: string }) => (
	<Icon size="medium" glyph={AutomationGlyph} label={label} secondaryColor="none" />
);

const jswEditionBenefits = new Map(
	Object.entries<Benefit[]>({
		canPay: [
			{
				icon: <InviteTeamIcon size="medium" label="People group icon" />,
				title: messages.jswStandardUnlimitedUsersTitle,
				description: messages.jswStandardUnlimitedUsersSubText,
			},
			{
				icon: <FileIcon size="medium" label="File icon" />,
				title: messages.jswStandardAuditLogTitle,
				description: messages.jswStandardAuditLogSubText,
			},
			{
				icon: <AutomationIcon label="Automation icon" />,
				title: messages.jswStandardAutomationsTitle,
				description: messages.jswStandardAutomationsSubText,
			},
			{
				icon: <UnlockFilledIcon size="medium" label="Unlock filled icon" />,
				title: messages.jswStandardIssuePermissionsTitle,
				description: messages.jswStandardIssuePermissionsSubText,
			},
		],
		notPay: [
			{
				icon: <InviteTeamIcon size="medium" label="People group icon" />,
				title: messages.jswStandardUnlimitedUsersTitle,
				description: messages.jswStandardUnlimitedUsersSubText,
			},
			{
				icon: <ExportIcon size="medium" label="Export icon" />,
				title: messages.jswStandardStorageTitle,
				description: messages.jswStandardStorageSubText,
			},
			{
				icon: <AutomationIcon label="Automation icon" />,
				title: messages.jswStandardAutomationsTitle,
				description: messages.jswStandardAutomationsSubText,
			},
		],
	}),
);

export const getBenefitsListContent = (canPay: boolean): Benefit[] | undefined =>
	canPay ? jswEditionBenefits.get('canPay') : jswEditionBenefits.get('notPay');
